<script setup lang="ts">
import { onMounted } from "vue";
// Thin route wrapper: `EditorShell.vue`'s main-content container is
// `position: relative`, matching what StoryboardBoard needs to fill it via
// `absolute inset-0` (previously it was nested inside `.zw-editor-shell`,
// which provided the same positioning context).
import StoryboardBoard from "./storyboard/StoryboardBoard.vue";
import { useOutlineEntitiesStore } from "../stores/useOutlineEntitiesStore";

const entities = useOutlineEntitiesStore();

onMounted(() => {
  void entities.refreshDatabase();
});
</script>

<template>
  <StoryboardBoard class="absolute inset-0 z-1 min-h-0" />
</template>
